import type moment from "moment";

export interface GuestlistAccessTypeFormState {
    quantity: number;
    entryType: server.dto.GuestlistEntryType;
    entryTypeCustomName: string;
}

export const getUpdateGuestlistAccessTypeInstruction = (
    guestlistAccessTypeId: number,
    state: GuestlistAccessTypeFormState,
): server.dto.UpdateGuestlistAccessTypeInstruction => ({
    guestlistAccessTypeId,
    quantity: state.quantity,
    entryType: state.entryType.value,
    entryTypeCustomName: state.entryTypeCustomName,
});

export interface GuestFormState {
    firstName: string;
    lastName: string;
    bringsGuests: number;
    list: server.dto.GuestlistList;
    email: string;
    mobile: string;
    passport: string;
    notes: string;
}

export const getUpdateGuestInstruction = (
    guestId: number,
    state: GuestFormState,
): server.dto.UpdateGuestInstruction => ({
    guestId,
    bringsGuests: state.bringsGuests,
    emailAddress: state.email,
    guestlistAccessTypeId: state.list.guestlistAccessTypeId,
    mobileNumber: state.mobile,
    name: {
        firstName: state.firstName,
        lastName: state.lastName,
    },
    notes: state.notes,
    passportNumber: state.passport,
});

export interface GuestlistConfigFormState {
    closingDate: moment.Moment;
    allowMultipleGuestsPerName: boolean;
    email: server.dto.FormElementBehaviors;
    mobileNumber: server.dto.FormElementBehaviors;
    passport: server.dto.FormElementBehaviors;
    notes: server.dto.FormElementBehaviors;
}

export const getUpdateGuestlistConfigInstruction = (
    guestlistId: number,
    state: GuestlistConfigFormState,
): server.dto.UpdateGuestlistConfigurationInstruction => ({
    allowMultipleGuestsPerName: state.allowMultipleGuestsPerName,
    deadlineUtc: state.closingDate.toDate(),
    guestEmailAddressFormBehavior: state.email,
    guestlistId,
    guestMobileNumberFormBehavior: state.mobileNumber,
    guestNotesFormBehavior: state.notes,
    guestPassportNumberFormBehavior: state.passport,
});
